import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { primeEnv, readEnv, RuntimeConfigError } from '@core/config/env';

import { App } from './App';
import { ConfigError } from './ConfigError';
import './styles/index.css';

const root = createRoot(document.getElementById('root')!);

// Read the runtime config before rendering anything. A white screen because env.js
// 404'd or was served stale is a bad first day; this turns it into a readable card.
try {
  const env = readEnv();
  primeEnv(env); // seed the lazy singleton with the value we just validated
  root.render(
    <StrictMode>
      <App env={env} />
    </StrictMode>,
  );
} catch (error) {
  root.render(
    <ConfigError
      missing={error instanceof RuntimeConfigError ? error.missing : []}
      message={error instanceof Error ? error.message : String(error)}
    />,
  );
}
